const EXP_NUMERO = /^[0-9\b]+$/;
const EXP_DNI = /^[0-9\b]{8}$/;
const EXP_CELULAR = /^[9]{1}[0-9\b]{8}$/;
const EXP_FECHA_NAC = /^(0[1-9]|[12][0-9]|3[01])[- /.](?:(0[1-9]|1[012])[- /.](19|20)[0-9]{2})$/;
export const KEYCODE_ENTER = 13;
export const PLD = 'PLD';
export const AUTO_NUEVO = 'AUTO_NUEVO';
export const AUTO_USADO = 'AUTO_USADO';
export const ESTUDIOS = 'ESTUDIOS';

export const ERROR_GENERICO = '0000';
export const ERROR_RENIEC = '0400';
export const ERROR_ASO = '0091';
export const ERROR_LISTCUSTOMER = '0007';
export const ERROR_LISTA_NEGRA_SEGUROS = '0009';
export const ERROR_REINTENTOS_DNI = '0027';
export const ERROR_REINTENTOS_FECHA = '0029';
export const ERROR_VERIFICACION_PENDIENTE = '0030';
export const ERROR_FUERA_HORARIO = '0031';
export const ERROR_FATCA = '0308';
export const PERSONA_BLOQUEADA = '016';
export const MOTOR_RIESGO_ERROR = '400';
export const MOTOR_RIESGO_TIMEOUT = '401';
export const MOTOR_RIESGO_LISTA_NEGRA = '402';
export const MOTOR_RIESGO_OTROS = '409';
export const SEGURO_LISTA_NEGRA = '012';
export const MOTOR_OFERTA_LISTA_NEGRA_BURO = '403';
export const MOTOR_OFERTA_LISTA_NEGRA_ESTRATEGIA = '404';
export const MOTOR_OFERTA_LISTA_NEGRA_MOI = '405';
export const MOTOR_OFERTA_LISTA_NEGRA_SCORE = '406';
export const MOTOR_OFERTA_LISTA_NEGRA_VALIDACIONES = '407';
export const MOTOR_OFERTA_OTROS = '410';
export const MOTOR_EVALUACION_LISTA_NEGRA_PREDECISION = '408';
export const MOTOR_EVALUACION_OTROS = '411';
export const MOTOR_EVALUACION_RECHAZADO = '412';
export const PEP = '014';
export const INELEGIBLE = '999';
export const SIN_OFERTA_VEH_NUEVO = '010';
export const SIN_OFERTA_VEH_USADO = '011';
export const SIN_OFERTA_ESTUDIOS = '020';
export const CELULAR_REPETIDO = '0025';
export const FECHA_INCORRECTA = '1005';
export const DIRECCION_NO_COINCIDE = '0419';
export const SMS_NO_COINCIDE = '0309';
export const EXCEDIO_INTENTO_SMS = '0310';
export const LIMITE_SOLICTAR_SMS = '0311';
export const ERROR_CONTRATACION = '0312';

export const PANTALLA_MOVIL = 768;

export const ERRORES = {
  [ERROR_GENERICO]: {descrip: 'error generico'},
  [ERROR_RENIEC]: {descrip: 'error reniec'},
  [ERROR_ASO]: {descrip: 'error aso'},
  [ERROR_LISTCUSTOMER]: {descrip: 'error list customer'},
  [ERROR_LISTA_NEGRA_SEGUROS]: {descrip: 'lista negra seguros error'},
  [ERROR_REINTENTOS_DNI]: {descrip: 'rechazado por limite ingresos'},
  [ERROR_REINTENTOS_FECHA]: {descrip: 'error fecha nacimiento'},
  [ERROR_VERIFICACION_PENDIENTE]: {descrip: 'no verificado'},
  [ERROR_FUERA_HORARIO]: {descrip: 'horario no disponible'},
  [ERROR_FATCA]: {descrip: 'nacionalidad extranjera'},
  [PERSONA_BLOQUEADA]: {descrip: 'persona bloqueada'},
  [MOTOR_RIESGO_ERROR]: {descrip: 'error motor'},
  [MOTOR_RIESGO_TIMEOUT]: {descrip: 'error motor'},
  [MOTOR_RIESGO_LISTA_NEGRA]: {descrip: 'lista negra'},
  [MOTOR_RIESGO_OTROS]: {descrip: 'otros 1'},
  [SEGURO_LISTA_NEGRA]: {descrip: 'lista negra de seguros'},
  [MOTOR_OFERTA_LISTA_NEGRA_BURO]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_LISTA_NEGRA_ESTRATEGIA]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_LISTA_NEGRA_MOI]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_LISTA_NEGRA_SCORE]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_LISTA_NEGRA_VALIDACIONES]: {descrip: 'lista negra 2'},
  [MOTOR_OFERTA_OTROS]: {descrip: 'otros 2'},
  [MOTOR_EVALUACION_LISTA_NEGRA_PREDECISION]: {descrip: 'lista negra 3'},
  [MOTOR_EVALUACION_OTROS]: {descrip: 'otros 3'},
  [MOTOR_EVALUACION_RECHAZADO]: {descrip: 'rechazado'},
  [PEP]: {descrip: 'pep'},
  [INELEGIBLE]: {descrip: 'error inelegible'},
  [SIN_OFERTA_VEH_NUEVO]: {descrip: 'sin oferta'},
  [SIN_OFERTA_VEH_USADO]: {descrip: 'sin oferta'},
  [SIN_OFERTA_ESTUDIOS]: {descrip: 'sin oferta'},
  [CELULAR_REPETIDO]: {},
  [FECHA_INCORRECTA]: {},
  [DIRECCION_NO_COINCIDE]: {descrip: 'direccion no coincide con reniec'},
  [SMS_NO_COINCIDE]: {descrip: 'sms no coincide'},
  [EXCEDIO_INTENTO_SMS]: {descrip: 'error intentos clave sms'},
  [LIMITE_SOLICTAR_SMS]: {descrip: 'limite solicitar sms'},
  [ERROR_CONTRATACION]: {descrip: 'error contratacion'},
};

export function autoScrollClassName(element){
  scrollearTC(element)
}

export function autoScrollByElemento(event) {
  let element = event.currentTarget;
  scrollear(element);
}

export function autoScrollFirtsError( typelement ) {

  const elementForFocus = function(elm) {
    const {classList} = elm;
    let array = Array.from(classList);
    if(array.includes('wrapper_dropDown')) {
      let container = elm.firstChild;
      let control = container ? container.firstChild : container;
      let valueContainer = control ? control.firstChild : control;
      return valueContainer ? valueContainer.children[1] : valueContainer;
    }
    return elm;
  };

  setTimeout(() => {
    let firtsElementError = document.getElementsByClassName(typelement ? 'Button__FatcaPep _error' : 'input--error')[0];
    if (firtsElementError) {
      scrollear(firtsElementError);
      let elementToMakeFocus = elementForFocus(firtsElementError);
      elementToMakeFocus.focus();
    };
  }, 100);
}

let scrollear = function (element) {

  let inIframeReact = function () {
			return window.self !== window.top;
		};

  var posicionIframe = 0;
  var alturaHeader = 0;
  var margenBlanco = 15;
  var topElemento = element.getBoundingClientRect().top;
  var elementHeader = window.document.getElementById('idMainHeader');
  var elementIframe = window.document.getElementById('iframeCuentasReact');

  if (inIframeReact()) {
		posicionIframe = elementIframe.getBoundingClientRect().top;
		alturaHeader = elementHeader ? elementHeader.offsetHeight : 0;
	}

  var valorAbsPosIframe = Math.abs(posicionIframe);
	var margen = Number(alturaHeader) + Number(valorAbsPosIframe);
  var moverScroll = topElemento - margen;

  window.scrollBy(0, moverScroll - margenBlanco);
};

let scrollearTC = function (element) {

  let inIframeReact = function () {
    return window.self !== window.top;
  };

  let posicionIframe = 0;
  let margen = 0;
  let alturaHeader = 0;
  let margenBlanco = 15;
  let topElemento = element.getBoundingClientRect().top;
  let elementHeader = window.document.getElementById('idMainHeader');
  let elementIframe = window.document.getElementById('iframeCuentasReact');

  if (inIframeReact()) {
    posicionIframe = elementIframe.getBoundingClientRect().top;
    alturaHeader = elementHeader ? elementHeader.offsetHeight : 0;
  }

  let valorAbsPosIframe = Math.abs(posicionIframe);

  if (posicionIframe > 0) {
    margen = Number(alturaHeader) - Number(valorAbsPosIframe);
  } else {
    margen = Number(alturaHeader) + Number(valorAbsPosIframe);
  }

  let moverScroll = topElemento - margen;

  window.scrollBy(0, moverScroll - margenBlanco);

};

export function inIframeReact() {
  return window.self !== window.top;
}

export function calcular_edad(fecNac) {
  var dia = fecNac.split('/')[0];
  var mes = fecNac.split('/')[1];
  var ano = fecNac.split('/')[2];
  let fecha_hoy = new Date();
  let ahora_ano = fecha_hoy.getYear();
  let ahora_mes = fecha_hoy.getMonth() + 1;
  let ahora_dia = fecha_hoy.getDate();

  // realizamos el calculo
  var edad = ahora_ano + 1900 - ano;
  if (ahora_mes < Number(mes)) {
    edad--;
  }
  if (Number(mes) === ahora_mes && ahora_dia < Number(dia)) {
    edad--;
  }
  if (edad > 1900) {
    edad -= 1900;
  }

  return edad;
}

export var soles = {
  symbol: 'S/',
  decimal: '.',
  thousand: ',',
  precision: 0,
  format: '%s%v',
};

export function formatDecimal(num) {
  return Number.parseFloat(num).toFixed(2);
}

export function obtenerMesActual() {
  return new Intl.DateTimeFormat('es-ES', {month: 'long'}).format(new Date());
}

export function obtenerUltimoDiaMes() {
  return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
}

export function inicialMayuscula(texto) {
  return texto ? texto[0].toUpperCase() + texto.slice(1).toLowerCase() : texto;
}

export function primerNombre(texto) {
  return texto ? texto.split(' ')[0] : texto;
}

export function cortarString(str, longitud) {
  return str.length > longitud ? str.slice(0, longitud).trim() : str.trim();
}

export const datosCabecera = {
  'mes': 'Mes',
  'dia': 'Día',
  'amortizacion': 'Amortización',
  'interes': 'Interés',
  'seguro': 'Seguro desgravamen',
  'total': 'Cuota',
  'saldo': 'Saldo',
};

export function formatoContador(time) {
  let minutos = Math.floor(time / 60);
  let segundos = time % 60;
  return ` ${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;
}

export function formatoTelefono(telefono) {
  return telefono.substr(0, 3) + ' ' + telefono.substr(3, 3) + ' ' + telefono.substr(6, 3);
}

export function setearValueDiaPago(diaPago) {
  return {value: diaPago, label: diaPago + ' de cada mes'};
}

export function setearValuePlazo(plazo) {
  return {value: plazo, label: plazo + ' meses'};
}

export function isFormatoCodigoSMS(value) {
  return (value === '' || EXP_NUMERO.test(value)) && value.length < 7;
}

export function isFormatoCelular(value) {
  return (value === '' || EXP_NUMERO.test(value)) && value.length < 10;
}

export function isFormatoDni(value) {
  return (value === '' || EXP_NUMERO.test(value)) && value.length < 9;
}

export function dniCorrecto(value) {
  return EXP_DNI.test(value);
}

export function fechaCorrecta(value) {
  return EXP_FECHA_NAC.test(value);
}

export function celularCorrecto(value) {
  return EXP_CELULAR.test(value);
}

export function construirObjFinal(data) {
  const objFinal = {
    idSesion: data.idSesion,
    flujo: data.flujo,
    dataContratacion: data.dataContratacion,
    dataPersona: data.dataPersona,
  };
  return objFinal;
}

export function cambiarAlturaIframe(height) {
  if (inIframeReact()) {
    if (height < window.top.innerHeight) {
      const altura = alturaHeader();
      window.frames['iframePrestamosReact'].style.height = `${altura}px`;
    } else {
      window.frames['iframePrestamosReact'].style.height = `${height}px`;
    }
  }
}

export function alturaHeader() {
  const valorArbitrario = 4;
  const alturaHeader = window.document.getElementById('idMainHeader').offsetHeight + valorArbitrario;
  return window.top.innerHeight - alturaHeader;
}